import { render, staticRenderFns } from "./materialIndex.vue?vue&type=template&id=33d73f8e&"
import script from "./materialIndex.vue?vue&type=script&lang=js&"
export * from "./materialIndex.vue?vue&type=script&lang=js&"
import style0 from "./materialIndex.vue?vue&type=style&index=0&id=33d73f8e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports